import { blue, grey } from '@mui/material/colors';

export default {
  styleOverrides: {
    colorInherit: {
      color: grey[600],
      '&:hover': {
        color: blue[500],
      },
    },
  },
};
